import React from "react";
import { useQueryClient } from 'react-query';
import { getSeason } from "../../../functions/GetSeason";
import useSeasons from "../../../services/settings/useSeasons";


const Season = (props) => {

  const queryClient = useQueryClient();
  let extraKeys = [props.slotFrom];
  const seasons = useSeasons({ queryClient, extraKeys: extraKeys});

  let season = null;
  if (seasons.data && Array.isArray(seasons.data) && seasons.data.length > 0) {
    season = getSeason(seasons.data, props.slotFrom);
    if (props.onChange) {
      props.onChange(season);
    }
  }

  return (
    props.code
      ?
        <div>{season ? season.seasonCode : ""}</div>
      :
        <div>{season ? `${season.seasonCode} - ${season.seasonName}` : ""}</div>
  );
}

export default Season;
